declare var $:any;

export class NotificationBuilder{

    showNotification(type, timer, message, from = 'top', align = 'right'){
        // var type = ['','info','success','warning','danger'];
        // var from = ['','top','bottom'];
        // var align = ['','left','center','right'];

    	$.notify({
        	message: message
        },{
            type: type,
            timer: timer,
            placement: {
                from: from,
                align: align
            }
        });
	}
}
